import React, { Component } from 'react';
import 'HELPDESK/Components/component.css';
import 'HELPDESK/Components/Dashboard/dashboard.css';
import config from 'config';
import { Link } from 'react-router-dom';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CoordinatorDetails from '../CoordinatorDetails/CoordinatorDetails';
import OnboardingDetails from '../OnboardingDetails/OnboardingDetails';
import DemoDetails from '../DemoDetails/DemoDetails';
import QueryDetails from '../QueryDetails/QueryDetails';

import ModuleCertification from '../ModuleCertification/ModuleCertification';
import HelpdeskApiCall from 'HelpdeskApiCall';
import RouteMenu from 'HELPDESK/CommonResources/RoutingMenu/RouteMenu';
import dashbord_img from "HELPDESK/CommonResources/images/Frame.png"
import dash2 from "HELPDESK/CommonResources/images/Dash 2.png";
import one from "HELPDESK/CommonResources/images/1.png";
import two from "HELPDESK/CommonResources/images/2.png"
import three from "HELPDESK/CommonResources/images/3.png"
import four from "HELPDESK/CommonResources/images/4.png"
import EarnRewards from '../EarnRewards/EarnRewards';
import serviceLogo from "HELPDESK/CommonResources/images/service.png"
import coordinateLogo from "HELPDESK/CommonResources/images/coordinate.png"
import logLogo from "HELPDESK/CommonResources/images/logbook.png"
import Onboarding from '../Onboarding/Onboarding';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentActiveLink: 'dashboard',
            accessResponse: '',
            onboardingAccess: false,
            logbookAccess: false,
            adminName: '',
            manageQueryLogbookName: '',
            manageOnboardingName: '',
            dueDate: '',
            viewMore: false,
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET INSTRUCTOR Service Request(s) COUNT
        this.apiCallToGetHelpDeskAccess();

        //get pending installment due date 
        // this.apiCallToGetHelpDeskPendingInstallmentDueDte();
    }

    // API CALL METHOD TO GET pending installment due date 
    // apiCallToGetHelpDeskPendingInstallmentDueDte = async () => {

    //     let requestData = {
    //         "iid": config.institute_id
    //     };

    //     let jsonResponse = await HelpdeskApiCall.makeApiCall(
    //         'GetHelpDeskPendingInstallmentDueDate',
    //         requestData,
    //         '/api/helpDesk/employee/Onboarding.php'
    //     );

    //     if (jsonResponse.expired) {
    //         setTimeout(() => {
    //             this.apiCallToGetHelpDeskPendingInstallmentDueDte()
    //         }, 1000);
    //     } else {
    //         if (jsonResponse.success) {
    //             let dueDate = jsonResponse.APIResult.dueDate;


    //             this.setState({
    //                 dueDate
    //             });
    //         }
    //         //  else {
    //         //     this.setState({
    //         //         successModal: true,
    //         //         successModalType: 'error',
    //         //         successMessage: 'Something went wrong while getting  with Service Request count. Please try again later.'
    //         //     });
    //         // }
    //     }
    // }

    // API CALL METHOD TO GET HELP DESK ACCESS
    apiCallToGetHelpDeskAccess = async () => {
        let requestData = {
            "facultyId": config.faculty_id,
            "iid": config.institute_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskAccessDetails',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetHelpDeskAccess()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let accessResponse = jsonResponse.APIResult.access_provided;
                let onboardingAccess = accessResponse.helpDeskOnboarding.isAccessGranted == "true" ? true : false;
                let logbookAccess = accessResponse.helpDeskLogbook.isAccessGranted == "true" ? true : false;

                let adminName = accessResponse.adminName;

                let manageQueryLogbookName = new Set();
                let logbookAccessGranted = accessResponse.helpDeskLogbook.accessGrantedTo;
                logbookAccessGranted.map(facultyData => {
                    manageQueryLogbookName.add(facultyData.name);
                });

                let manageOnboardingName = new Set();
                let helpDeskOnboardingAccessGranted = accessResponse.helpDeskOnboarding.accessGrantedTo;
                helpDeskOnboardingAccessGranted.map(facultyData => {
                    manageOnboardingName.add(facultyData.name);
                });

                this.setState({
                    accessResponse,
                    onboardingAccess,
                    logbookAccess,
                    adminName,
                    manageQueryLogbookName: Array.from(manageQueryLogbookName).join(', '),
                    manageOnboardingName: Array.from(manageOnboardingName).join(', ')
                });
            } else {
                this.setState({
                    instructorListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting instructor list with Service Request count. Please try again later.'
                });
            }
        }
    }

    checkAccess = (accessKey) => {
        let currentActiveLink = (accessKey == "coordinatorAccess" ? 'coordinator' : accessKey == "onboardingAccess" ? 'onboarding' : 'logbook');
        this.setState({ currentActiveLink });
    }

    // METHOD TO SELECT MENU
    selectMenu = (menu) => {
        this.setState({
            currentActiveLink: menu
        });
    }

    // METHOD TO CLOSE LINK DETAILS
    closeLinkDetails = () => {
        this.setState({
            currentActiveLink: 'dashboard'
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    ModalToViewMore = () => {
        return (
            <div className={this.state.viewMore ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "70vw" }}>
                    <div className="modal-content">
                        <div style={{ padding: "10px" }}>

                            <FontAwesomeIcon icon={['fas', 'times-circle']} style={{ cursor: 'pointer', float: "right" }} size="lg" color="#D2D2D6" onClick={() => this.setState({ viewMore: false })} />
                        </div>
                        <div className="modal-body overflow-hidden" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ width: "35%" }}>
                                <img src={dash2} style={{ width: "100%" }} alt='learnMore' />
                            </div>
                            <div style={{ width: "65%", color: "#4A4B57", padding: "20px" }}>
                                <p style={{ fontWeight: "bold", fontSize: "20px" }}>How to get started ?</p>

                                <div className='infoDiv'>
                                    <div style={{ width: "12%" }}>
                                        <img src={one} alt='1' style={{ width: "100%" }} />
                                    </div>
                                    <p className='mt-2 ml-1' style={{ width: "88%" }}>
                                        <b>Assign Point of Contact (POC)</b> for modules to help users with their questions and provide valuable support.
                                    </p>
                                </div>

                                <div className='infoDiv'>
                                    <div style={{ width: "13%" }}>
                                        <img src={two} alt='1' style={{ width: "100%" }} />
                                    </div>
                                    <p className='mt-2' style={{ width: "87%" }}>
                                        Watch <b>Free Training Tutorials</b> and <b>get certified</b> in particular module.
                                    </p>
                                </div>
                                <div className='infoDiv'>
                                    <div style={{ width: "13%" }}>
                                        <img src={three} alt='1' style={{ width: "100%" }} />
                                    </div>
                                    <p className='mt-2' style={{ width: "87%" }}>
                                        <b>Conduct online trainings</b> according to your available timings slots for faculty members of other colleges and earn remuneration.</p>

                                </div>
                                <div className='infoDiv'>
                                    <div style={{ width: "13%" }}>
                                        <img src={four} alt='1' style={{ width: "100%" }} />
                                    </div>
                                    <p className='mt-2' style={{ width: "87%" }}>
                                        Book <b>Training Demo</b> from vmedulife coordinators.</p>
                                </div>
                                <button onClick={() => this.setState({ viewMore: false }, () => this.selectMenu("moduleCertification"))} style={{ marginBottom: "20px", boxShadow: "#5C2FAB 0px 2px 8px 0px", backgroundColor: "#5C2FAB", color: "white", borderRadius: "50px", fontSize: "12px", fontWeight: "bold", padding: "8px 20px", border: "none", marginTop: "15px" }}>
                                    Start Now
                                </button>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div >
                <RouteMenu
                    activeScreen={this.state.currentActiveLink}
                    selectMenu={this.selectMenu}
                />
                {
                    <div className="helpdeskComponents">
                        {
                            this.state.currentActiveLink == 'coordinator' ?
                                <CoordinatorDetails
                                    closeLinkDetails={this.closeLinkDetails}
                                />
                                :
                                this.state.currentActiveLink == 'onboarding' ?
                                    <OnboardingDetails
                                        closeLinkDetails={this.closeLinkDetails}
                                    />
                                    :
                                    this.state.currentActiveLink == 'demo' ?
                                        <DemoDetails
                                            closeLinkDetails={this.closeLinkDetails}
                                        />
                                        :
                                        this.state.currentActiveLink == 'query' ?
                                            <QueryDetails
                                                closeLinkDetails={this.closeLinkDetails}
                                            />
                                            :
                                            this.state.currentActiveLink == 'productOnboarding' ?
                                                <Onboarding
                                                    closeLinkDetails={this.closeLinkDetails}
                                                />
                                                :
                                                
                                                    this.state.currentActiveLink == 'moduleCertification' ?
                                                        <ModuleCertification
                                                            closeLinkDetails={this.closeLinkDetails}
                                                        />
                                                        :
                                                        this.state.currentActiveLink == 'earnRewards' ?
                                                            <EarnRewards
                                                                closeLinkDetails={this.closeLinkDetails}
                                                            />
                                                            :

                                                            <div style={{ height: "88vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingTop: "30px" }}>

                                                                <div className="helpdeskComponents" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "40px" }}>

                                                                    <div style={{ width: "35%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                        <div>
                                                                            <p style={{ color: "#B6B6B6", fontWeight: "bold", fontSize: "14px" }}>HELPDESK</p>
                                                                            <p style={{ fontWeight: "bold", fontSize: "25px", color: "#5A5B6A" }}>Educate Others !</p>
                                                                            <p style={{ fontWeight: "900", fontSize: "35px", color: "#FD9329" }}>Earn Rewards !</p>
                                                                            <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
                                                                                <button onClick={() => this.selectMenu("earnRewards")} style={{ boxShadow: "#5C2FAB 0px 2px 8px 0px", backgroundColor: "#5C2FAB", color: "white", borderRadius: "50px", fontSize: "12px", fontWeight: "bold", padding: "8px 20px", border: "none" }}>
                                                                                    Start Now
                                                                                </button>

                                                                                {/* <button onClick={() => this.setState({ viewMore: true })} style={{ boxShadow: "#5C2FAB 0px 2px 8px 0px", backgroundColor: "white", color: "#5C2FAB", borderRadius: "50px", fontSize: "12px", fontWeight: "bold", padding: "8px 20px", border: "none" }}>
                                                                            Learn more
                                                                        </button> */}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div style={{ height: "35vh", position: "relative", right: "10%" }}>
                                                                        <img src={dashbord_img} style={{ width: "100%", height: "100%" }} alt="dashboard image" />
                                                                    </div>


                                                                </div>
                                                                <div className='threedivs'>

                                                                    <div className='redirect' onClick={() => this.selectMenu("query")}>
                                                                        <img src={serviceLogo} style={{ width: "30px", height: "30px" }} />
                                                                        <p>Service Request(s)</p>
                                                                        <p className='tabinfo'>Add new service request for modules and get it resolved</p>
                                                                    </div>

                                                                    <div className='redirect' onClick={() => this.selectMenu("coordinator")}>
                                                                        <img src={coordinateLogo} style={{ width: "35px", height: "30px" }} />
                                                                        <p>Co-Ordinators</p>
                                                                        <p className='tabinfo'>Manage co-ordinators of your organization</p>
                                                                    </div>


                                                                    {/* <div className='redirect' onClick={() => this.selectMenu("logbook")}>
                                                                        <img src={logLogo} style={{ width: "25px", height: "27px" }} />
                                                                        <p>Logbook</p>
                                                                        <p className='tabinfo'>View all service request(s) for modules of your organization</p>
                                                                    </div> */}


                                                                </div>
                                                                <div className='stage'>

                                                                </div>
                                                            </div>
                        }
                    </div>


                }
                {
                    this.ModalToViewMore()
                }
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
            </div>
        );
    }
}

export default Dashboard;